module.exports = __webpack_public_path__ + "img/engineering-and-design.bf8f9935.jpg";